<template>
    <div class="hall-update-wrapper">
        <a-modal
            class="hall-update"
            :visible="visible"
            :title="form.getFieldValue('id') ? $t('program.update_hall' /* 修改会场 */) : $t('program.add_hall' /* 添加会场 */)"
            :width="600"
            :maskClosable="false"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
        >
            <a-form :form="form">
                <a-form-item :hidden="true">
                    <a-input v-decorator="['id']"></a-input>
                </a-form-item>
                <a-form-item :label="$t('program.cn_name' /* 中文名称 */)">
                    <a-input
                        v-decorator="['meeting_hall', { rules: [{ required: true, message: $t('program.hall_cn_name_placeholder' /* 请填写会场中文名称 */) }] }]"
                        :placeholder="$t('program.hall_cn_name_placeholder' /* 请填写会场中文名称 */)"
                    ></a-input>
                </a-form-item>
                <a-form-item :label="$t('program.en_name' /* 英文名称 */)">
                    <a-input v-decorator="['meeting_hall_en']" :placeholder="$t('program.hall_en_name_placeholder' /* 请填写会场英文名称 */)"></a-input>
                </a-form-item>
                <a-form-item :label="$t('program.hall_login_account' /* 会场登录账号（幻灯系统Online版） */)">
                    <a-input v-decorator="['user_name']" :placeholder="$t('program.hall_login_account_placeholder' /* 请填写会场登录账号 */)"></a-input>
                </a-form-item>
                <a-form-item :label="$t('program.hall_login_password' /* 会场登录密码（幻灯系统Online版） */)">
                    <a-input v-decorator="['password']" :placeholder="$t('program.hall_login_password_placeholder' /* 请填写会场登录密码 */)"></a-input>
                </a-form-item>
                <a-form-item :label="$t('program.hall_ad_open' /* 是否开启场外广告 */)">
                    <a-radio-group name="ad_open_state" v-decorator="['ad_open_state']">
                        <a-radio :value="0">{{ $t('formConfig.no' /* 否 */) }}</a-radio>
                        <a-radio :value="1">{{ $t('formConfig.yes' /* 是 */) }}</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item :label="$t('program.hall_computer_ip' /* 会场电脑ip */)">
                    <a-input v-decorator="['password']" :placeholder="$t('program.hall_computer_ip_placeholder' /* 请填写会场电脑ip */)"></a-input>
                </a-form-item>
                <a-form-item :label="$t('program.sorting' /* 排序 */)">
                    <a-input-number
                        v-decorator="['orderbyid', { initialValue: 0, rules: [{ required: true, message: $t('program.hall_sorting_placeholder' /* 请填写排序 */) }] }]"
                        :placeholder="$t('program.hall_sorting_placeholder' /* 请填写排序 */)"
                    ></a-input-number>
                </a-form-item>
                <a-form-item :label="$t('program.abstract_type' /* 可选论文类别 */)">
                    <a-select v-decorator="['abs_class']">
                        <a-select-option v-for="item in abstractTypeList" :key="item.id" :value="item.id">{{ $route.params.lang == 'cn' ? item.name : item.name_en }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('formConfig.remark' /* 备注 */)">
                    <a-textarea v-decorator="['remarks']" :placeholder="$t('program.hall_remarks_placeholder' /* 请填写备注 */)" :rows="4"></a-textarea>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
import pick from 'lodash.pick';

const fileds = ['meeting_hall', 'meeting_hall_en', 'user_name', 'password', 'ad_open_state', 'orderbyid', 'remarks', 'id', 'abs_class'];

export default {
    name: 'HallUpdateModal',
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this),
            programSet: {}, // 日程相关配置
            abstractTypeList: [] // 可选论文类别下拉
        };
    },
    methods: {
        show(data) {
            this.visible = true;
            if (data && data.id) {
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(data, fileds));
                });
            }
        },
        /**
         * ## 获取日程配置
         */
        getProgramSetFun() {
            this.$request.get({ url: 'getProgramSet' }).then(res => {
                this.programSet = res.data;
            });
        },
        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = true;
                    values.hall_id = values.id;
                    delete values.id;
                    this.$request
                        .post({ url: 'addEditHall', data: values })
                        .then(res => {
                            this.$message.success(this.form.getFieldValue('id') ? this.$t('web.modify_success' /* 修改成功 */) : this.$t('web.add_success' /* 添加成功 */));
                            this.confirmLoading = false;
                            this.handleCancel();
                            this.$emit('closeHallUpdate');
                        })
                        .finally(() => {
                            this.confirmLoading = false;
                        });
                }
            });
        },
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        },
        /**
         * ## 获取可选论文类别
         */
        getAbstractTypeList() {
            this.$request.get({ url: 'getProgramAbsClassList' }).then(res => {
                this.abstractTypeList = res.data;
            });
        }
    },
    mounted() {
        this.getProgramSetFun();
        this.getAbstractTypeList();
    }
};
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-input-number {
    width: 100%;
}
</style>
